import {URL_BASE} from "../../../Globals.ts";
import {getIdToken} from "../../misc/miscUtils.ts";

export const addNewChatToHistory = async (message: string | undefined, isIncognito: boolean, updateChatHistory: any, conversationId: string, user: any) => {
    if (!user || isIncognito) return;

    const token = await getIdToken(user);

    let newChatName = "New Chat";

    try {
        const url = `${URL_BASE}/api/nameChat`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ message: message ? message : "", conversationId: conversationId })
        });

        if (response.ok) {
            const responseData = await response.json();
            const { chatName } = responseData;

            newChatName = chatName;
        } else {
            console.error(`Error giving chat name: ${response.statusText}`);
        }
    } catch (error) {
        console.error(`Error giving chat name: ${error}`);
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString();
    const formattedTime = currentDate.toLocaleTimeString();

    updateChatHistory({id: conversationId, name: newChatName, firstAccessedDate: formattedDate,  lastAccessedDate: formattedDate, lastAccessedTimestamp: formattedTime, isFavorite: false}, 'add');
};

export const editChatName = async (newName: string, updateChatHistory: any, conversationId: string, user: any) => {
    if (!user) return;
    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/editChatName`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ newName: newName, conversationId: conversationId })
        });

        updateChatHistory({id: conversationId, newName: newName}, "edit");
    } catch (error) {
        console.error(`Error giving chat name: ${error}`);
    }
};

export const deleteChat = async (user: any, conversationId: string, focusedChatId: string, updateChatHistory: any, resetStateHelper: any) => {
    if (!user) return;
    const token = await getIdToken(user);

    try {
        if (conversationId === focusedChatId) {
            await resetStateHelper();
        }

        const url = `${URL_BASE}/api/deleteChat`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({conversationId: conversationId})
        });

        updateChatHistory(conversationId, "delete");
    } catch (error) {
        console.error(`Error giving chat name: ${error}`);
    }
};

export const clearChatHistory = async (isIncognito: boolean, user: any, setDynamicStateObj: any, resetStateHelper: any) => {
    if (!user) return;
    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/clearChatHistory`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (!isIncognito) resetStateHelper();
        setDynamicStateObj({chatHistory: []});
    } catch (error) {
        console.error(`Error giving chat name: ${error}`);
    }
};

export const updateMessagesSequenceState = async (user: any, isIncognito: boolean, conversationId: string, messagesSequence: number[]) => {
    if (!user || isIncognito) return;
    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/updateMessagesSequenceState`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({messagesSequence: messagesSequence, conversationId: conversationId })
        });
    } catch (error) {
        console.error(`Error giving messages sequence: ${error}`);
    }
};

export const updateMessageImportanceState = async (user: any, isIncognito: boolean, conversationId: string, messageId: string, isImportant: boolean) => {
    if (!user || isIncognito) return;
    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/updateMessageImportanceState`;

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({conversationId: conversationId, messageId: messageId, isImportant: isImportant })
        });
    } catch (error) {
        console.error(`Error updating message importance state: ${error}`);
    }
};

export const toggleChatFavorite = async (user: any, conversationId: string, isFavorite: boolean, updateChatHistory: any) => {
    if (!user) return;
    const token = await getIdToken(user);

    try {
        const url = `${URL_BASE}/api/toggleChatFavorite`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ conversationId: conversationId, isFavorite: isFavorite })
        });

        updateChatHistory({id: conversationId, isFavorite: isFavorite}, "toggleFavorite");
    } catch (error) {
        console.error(`Error toggling chat favorite: ${error}`);
    }
};